module.exports = __webpack_public_path__ + "media/application/images/svgs/icon_location-86e3dd0d2fc291252260fd612886ae54.svg";